import { render, staticRenderFns } from "./PagamentoItemsTable.vue?vue&type=template&id=f085ee02&scoped=true"
import script from "./PagamentoItemsTable.vue?vue&type=script&lang=js"
export * from "./PagamentoItemsTable.vue?vue&type=script&lang=js"
import style0 from "./PagamentoItemsTable.vue?vue&type=style&index=0&id=f085ee02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f085ee02",
  null
  
)

export default component.exports